function isValidCurrency(currency?: string, locale = 'ro-RO'): boolean {
  if (!currency) return false

  try {
    // Will throw if the currency code is invalid for Intl
    new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      currencyDisplay: 'narrowSymbol'
    }).format(1)

    return true
  } catch {
    return false
  }
}

function formatNumberWithCurrency(
  value: number | string,
  currency = '',
  locale = 'ro-RO',
  options?: Intl.NumberFormatOptions
): string {
  if (value === null || value === undefined || value === '') return ''
  const num = typeof value === 'number' ? value : Number(value)
  if (Number.isNaN(num)) return ''

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currencyDisplay: 'narrowSymbol',
    currency,
    ...options
  }).format(num)
}
function formatNumber(
  value: number | string,
  locale = 'ro-RO',
  options?: Intl.NumberFormatOptions
): string {
  if (value === null || value === undefined || value === '') return ''
  const num = typeof value === 'number' ? value : Number(value)
  if (Number.isNaN(num)) return ''

  return new Intl.NumberFormat(locale, {
    ...options
  }).format(num)
}

export const composePrice = (
  amount?: number | string | null,
  currency?: string
) => {
  if (amount == null || amount === '') return ''

  if (isValidCurrency(currency)) {
    return formatNumberWithCurrency(amount, currency)
  }

  const formatted = formatNumber(amount)

  return currency ? `${formatted} ${currency}` : formatted
}

export function calculateDiscount(
  initialPrice: number | string,
  finalPrice: number | string,
  locale = 'ro-MD',
  fractionDigits = 2
): string {
  const initial = Number(initialPrice)
  const final = Number(finalPrice)

  if (!Number.isFinite(initial) || !Number.isFinite(final) || initial <= 0) {
    return '0%'
  }

  const discount = initial - final
  if (discount <= 0) return '0%'

  const ratio = discount / initial // e.g. 0.25

  return new Intl.NumberFormat(locale, {
    style: 'percent',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits
  }).format(ratio) // e.g. "25%"
}
